import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import permissionReducer from './slices/permissionSlice';
import roleReducer from './slices/roleSlice';
import userReducer from './slices/userSlice';
import organizationReducer from './slices/organizationSlice';
import memberReducer from './slices/main/memberSlice';
import broadcastReducer from './slices/main/broadcastSlice';
import automationReducer from './slices/main/automationSlice';
import birthdayReducer from './slices/engagement/birthdaySlice';
import pollReducer from './slices/engagement/pollSlice';
import devotionalReducer from './slices/engagement/devotionalSlice';
import eventReducer from './slices/engagement/eventSlice';
import inboxReducer from './slices/engagement/inboxSlice';
import prayerReducer from './slices/engagement/prayerSlice';
import groupReducer from './slices/reports/groupSlice'
import branchReducer from './slices/system/branchSlice';
import shortcodeReducer from './slices/system/shortcodeSlice';
import dripCampaignReducer from './slices/growth/dripCampaignSlice';
import visitorReducer from './slices/growth/visitorSlice';
import givingReducer from './slices/growth/givingCampaignSlice';
import chatbotReducer from './slices/growth/chatbotSlice';
import memberHealthReducer from './slices/growth/memberHealthSlice';
import senderIdReducer from './slices/system/senderIdSlice';
import smsBalanceReducer from './slices/system/smsBalanceSlice';
import pricingReducer from './slices/system/pricingSlice';

import featureReducer from './slices/frontend/featureSlice';
import testimonialReducer from './slices/frontend/testimonialSlice';
import statReducer from './slices/frontend/statSlice';
import regionReducer from './slices/frontend/regionSlice';
import pricingPlanReducer from './slices/frontend/pricingPlanSlice';
import blogPostReducer from './slices/frontend/blogPostSlice';
import settingReducer from './slices/frontend/settingSlice';
import dashboardReducer from './slices/main/dashboardSlice';


import { groups } from '../data/mockData';

const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    auth: authReducer,
    permissions: permissionReducer,
    roles: roleReducer,
    users: userReducer,
    organizations: organizationReducer,
    members: memberReducer,
    broadcasts: broadcastReducer,
    automations: automationReducer,
    birthday: birthdayReducer,

    polls: pollReducer,
    devotionals: devotionalReducer,
    events: eventReducer,
    inbox: inboxReducer,
    prayers: prayerReducer,
    groups:groupReducer,
    branches:branchReducer,
    shortcodes: shortcodeReducer,
    dripCampaigns: dripCampaignReducer,
    visitors: visitorReducer,
    givingCampaigns: givingReducer,
    chatbot: chatbotReducer,
    memberHealth: memberHealthReducer,
    senderId: senderIdReducer,
    smsBalance: smsBalanceReducer,
    pricing: pricingReducer,
    features: featureReducer,
    testimonials: testimonialReducer,
    stats: statReducer,
    regions: regionReducer,
    pricingPlans: pricingPlanReducer,
    blogPosts: blogPostReducer,
    settings: settingReducer,
  },
  // Optional: Add middleware configuration
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Only if needed
    }),
});

export default store;